<mat-drawer-container id="integrations_add_edit_main_container" autosize>
  <mat-card>
    <mat-card-content class="form-mat-card-content">
      <div id="integrations_add_edit_header" class="page-header">
        <span id="integrations_add_edit_header_text" class="page-header-text">
          @if (pageType() === action.create) {
            <span>Create {{ apiDetails()?.name }} Integration</span>
          } @else if (pageType() === action.edit) {
            <span>Edit {{ apiDetails()?.name }} Integration : {{ pageNameTitle() }}</span>
          }
        </span>
        <span class="spacer"></span>
        <button
          mat-button
          id="integrations_add_edit_cancel_1"
          class="add-edit-button white-button margin-right-15"
          (click)="openWarningDialog()">
          Cancel
        </button>
        <button
          mat-button
          id="integrations_add_edit_save"
          class="add-edit-button save-button"
          [ngClass]="{ 'invalid-button': !integrationForm.valid }"
          (click)="onSubmit(integrationForm)">
          Save
        </button>
      </div>
      <hr class="custom-hr" />
      @if (!loading() && !formPrepareError()) {
        <div class="form-holder">
          <form
            id="integration_form"
            class="custom-form grid-form api-form"
            [formGroup]="integrationForm">
            <span id="contact_header" class="section-header">Contact Information</span>
            <div class="span-all-cols"><hr /></div>

            <!-- Contact Information Inputs -->
            <div id="integrations_add_edit_contact_name">
              <div id="form_input_title_contact_name" class="form-input-title">Contact Name:</div>
              <mat-form-field
                id="integration_contact_name_field"
                class="form-field-custom form-field-input">
                <input
                  matInput
                  id="integration_contact_name_input"
                  maxlength="50"
                  class="shared-input-field"
                  formControlName="contactName"
                  autocomplete="off" />
                <span class="error-space-holder"> </span>
              </mat-form-field>
            </div>
            <div id="integrations_add_edit_contact_phone">
              <div id="form_input_title_contact_phone" class="form-input-title">Contact Phone:</div>
              <mat-form-field
                id="integration_contact_phone_field"
                class="form-field-custom form-field-input">
                <input
                  matInput
                  id="integration_contact_phone_input"
                  maxlength="25"
                  class="shared-input-field"
                  formControlName="contactPhone"
                  autocomplete="off" />
                <span class="error-space-holder"> </span>
              </mat-form-field>
            </div>
            <div id="integrations_add_edit_contact_email" class="span-all-cols">
              <div id="form_input_title_contact_email" class="form-input-title">Contact Email:</div>
              <mat-form-field
                id="integration_contact_email_field"
                class="form-field-custom form-field-input">
                <input
                  matInput
                  id="integration_contact_email_input"
                  maxlength="50"
                  class="shared-input-field"
                  formControlName="contactEmail"
                  autocomplete="off"
                  type="email" />
                <span class="error-space-holder">
                  @if (
                    integrationForm.controls['contactEmail'].touched &&
                    !integrationForm.controls['contactEmail'].valid
                  ) {
                    <mat-error id="integration_email_error" class="error input-error">
                      <i class="fas fa-exclamation-triangle error-icon"></i
                      >{{ getErrorMessage('contactEmail') }}
                    </mat-error>
                  }
                </span>
              </mat-form-field>
            </div>
            <!-- Contact Information Inputs End -->
            <span id="api_header" class="section-header">API Details</span>
            <div class="span-all-cols"><hr /></div>

            <!-- Required Vendor Information Inputs -->
            <div id="integrations_add_edit_name">
              <div id="form_input_title_name" class="form-input-title">Vendor Name:</div>
              <mat-form-field
                id="integration_name_field"
                class="form-field-custom form-field-input">
                <input
                  matInput
                  id="integration_name_input"
                  maxlength="50"
                  class="shared-input-field"
                  formControlName="vendorName"
                  autocomplete="off"
                  (focus)="onInputFocus('vendorName')"
                  (blur)="onInputBlur('vendorName')" />
              </mat-form-field>
              <span class="error-space-holder">
                @if (
                  (integrationForm.controls['vendorName'].touched &&
                    integrationForm.controls['vendorName'].errors !== null &&
                    !focusState()['vendorName']) ||
                  integrationForm.controls['vendorName'].hasError('isNotUnique')
                ) {
                  <mat-error id="integration_name_error" class="error input-error">
                    <i class="fas fa-exclamation-triangle error-icon"></i
                    >{{ getErrorMessage('vendorName') }}
                  </mat-error>
                }
              </span>
            </div>
            <div id="integrations_add_edit_key">
              <div id="form_input_title_key" class="form-input-title">Vendor Key:</div>
              <mat-form-field id="integration_key_field" class="form-field-custom form-field-input">
                <input
                  matInput
                  id="integration_key_input"
                  maxlength="50"
                  class="shared-input-field lowercase-input"
                  formControlName="vendorKey"
                  autocomplete="off"
                  (focus)="onInputFocus('vendorKey')"
                  (blur)="onInputBlur('vendorKey')" />
              </mat-form-field>
              <span class="error-space-holder">
                @if (
                  (integrationForm.controls['vendorKey'].touched &&
                    integrationForm.controls['vendorKey'].errors !== null &&
                    !focusState()['vendorKey']) ||
                  integrationForm.controls['vendorKey'].hasError('isNotUnique')
                ) {
                  <mat-error id="integration_key_error" class="error input-error">
                    <i class="fas fa-exclamation-triangle error-icon"></i
                    >{{ getErrorMessage('vendorKey') }}
                  </mat-error>
                }
              </span>
            </div>
            <div id="integrations_add_edit_api_type">
              <div id="form_input_title_api_type" class="form-input-title">Integration Type:</div>
              <mat-form-field
                id="integration_api_type_field"
                class="form-field-custom add-edit-dropdown">
                <mat-select formControlName="integrationType">
                  @for (type of integrationTypes(); track type) {
                    <mat-option id="integration_enabled_options" [value]="type">
                      {{ type.name }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            <div id="integrations_add_edit_push_url">
              <div id="form_input_title_push_url" class="form-input-title">Push Endpoint:</div>
              <mat-form-field
                id="integration_push_url_field"
                class="form-field-custom form-field-input">
                <input
                  matInput
                  id="integration_push_url_input"
                  class="shared-input-field"
                  formControlName="pushUrl"
                  autocomplete="off"
                  (focus)="onInputFocus('pushUrl')"
                  (blur)="onInputBlur('pushUrl')" />
              </mat-form-field>
              <span class="error-space-holder">
                @if (
                  integrationForm.controls['pushUrl'].touched &&
                  !integrationForm.controls['pushUrl'].valid &&
                  !focusState()['pushUrl']
                ) {
                  <mat-error id="integration_push_url_error" class="error input-error">
                    <i class="fas fa-exclamation-triangle error-icon"></i
                    >{{ getErrorMessage('pushUrl') }}
                  </mat-error>
                }
              </span>
            </div>
            <div id="integrations_add_edit_customers">
              <div id="form_input_title_customers" class="form-input-title">Select Customers:</div>
              <mat-form-field
                id="integration_customers_field"
                class="form-field-custom add-edit-dropdown">
                <mat-select
                  id="customer_select"
                  class="uppercase customer-select"
                  formControlName="customers"
                  placeholder="Customers"
                  multiple>
                  @for (customer of customers(); track customer) {
                    <mat-option
                      id="integration_customers_options_{{ customer }}"
                      class="uppercase"
                      [value]="customer.customerKey">
                      {{ customer.customerKey }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <span class="error-space-holder">
                @if (
                  integrationForm.controls['customers'].touched &&
                  !integrationForm.controls['customers'].valid
                ) {
                  <mat-error id="integration_customers_error" class="error input-error">
                    <i class="fas fa-exclamation-triangle error-icon"></i
                    >{{ getErrorMessage('customers') }}
                  </mat-error>
                }
              </span>
            </div>
            <div id="integrations_add_edit_auth_type">
              <div id="form_input_title_auth_type" class="form-input-title">
                Authentication Type:
              </div>
              <mat-form-field
                id="integration_auth_type_field"
                class="form-field-custom add-edit-dropdown">
                <mat-select
                  id="auth_type_select"
                  formControlName="authType"
                  (selectionChange)="changeValidators($event.value)">
                  @for (type of authTypes(); track type) {
                    <mat-option id="integration_auth_type_options_{{ type }}" [value]="type">
                      {{ type.authMethod }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <span class="error-space-holder">
                @if (
                  integrationForm.controls['authType'].touched &&
                  !integrationForm.controls['authType'].valid
                ) {
                  <mat-error id="integration_auth_type_error" class="error input-error">
                    <i class="fas fa-exclamation-triangle error-icon"></i
                    >{{ getErrorMessage('authType') }}
                  </mat-error>
                }
              </span>
            </div>
            <!-- Required Vendor Information Inputs End -->

            @if (isApiKeyAuth || isOauthAuth) {
              <div id="integrations_add_edit_apikey_header_name">
                <div id="form_input_title_apikey_header_name" class="form-input-title">
                  API Key Header Name:
                </div>
                <mat-form-field
                  id="integration_apikey_header_name_field"
                  class="form-field-custom form-field-input">
                  <input
                    matInput
                    id="integration_apikey_header_name_input"
                    class="shared-input-field"
                    formControlName="apiKeyHeaderName"
                    autocomplete="off" />
                </mat-form-field>
                <span class="error-space-holder">
                  @if (
                    integrationForm.controls['apiKeyHeaderName'].touched &&
                    !integrationForm.controls['apiKeyHeaderName'].valid
                  ) {
                    <mat-error id="integration_apikey_header_name_error" class="error input-error">
                      <i class="fas fa-exclamation-triangle error-icon"></i
                      >{{ getErrorMessage('apiKeyHeaderName') }}
                    </mat-error>
                  }
                </span>
              </div>
            }
            @if (isApiKeyAuth || isOauthAuth) {
              <div id="integrations_add_edit_api_key">
                <div id="form_input_title_api_key" class="form-input-title">Api Key:</div>
                <mat-form-field
                  id="integration_api_key_field"
                  class="form-field-custom form-field-input">
                  <input
                    matInput
                    id="integration_api_key_input"
                    class="shared-input-field"
                    formControlName="apiKey"
                    autocomplete="off" />
                </mat-form-field>
                <span class="error-space-holder">
                  @if (
                    integrationForm.controls['apiKey'].touched &&
                    !integrationForm.controls['apiKey'].valid
                  ) {
                    <mat-error id="integration_api_key_error" class="error input-error">
                      <i class="fas fa-exclamation-triangle error-icon"></i
                      >{{ getErrorMessage('apiKey') }}
                    </mat-error>
                  }
                </span>
              </div>
            }
            @if (isJwtAuth || isOauthAuth) {
              <div id="integrations_add_edit_auth_url">
                <div id="form_input_title_auth_url" class="form-input-title">
                  Authentication Endpoint:
                </div>
                <mat-form-field
                  id="integration_auth_url_field"
                  class="form-field-custom form-field-input">
                  <input
                    matInput
                    id="integration_auth_url_input"
                    class="shared-input-field"
                    formControlName="authEndpointUrl"
                    autocomplete="off"
                    (focus)="onInputFocus('authEndpointUrl')"
                    (blur)="onInputBlur('authEndpointUrl')" />
                </mat-form-field>
                <span class="error-space-holder">
                  @if (
                    integrationForm.controls['authEndpointUrl'].touched &&
                    !integrationForm.controls['authEndpointUrl'].valid &&
                    !focusState()['authEndpointUrl']
                  ) {
                    <mat-error id="integration_auth_url_error" class="error input-error">
                      <i class="fas fa-exclamation-triangle error-icon"></i
                      >{{ getErrorMessage('authEndpointUrl') }}
                    </mat-error>
                  }
                </span>
              </div>
            }
            @if (isJwtAuth) {
              <div id="integrations_add_edit_auth_username">
                <div id="form_input_title_auth_username" class="form-input-title">
                  Authentication Username:
                </div>
                <mat-form-field
                  id="integration_auth_username_field"
                  class="form-field-custom form-field-input">
                  <input
                    matInput
                    id="integration_auth_username_input"
                    class="shared-input-field"
                    formControlName="authUsername"
                    autocomplete="off" />
                </mat-form-field>
                <span class="error-space-holder">
                  @if (
                    integrationForm.controls['authUsername'].touched &&
                    !integrationForm.controls['authUsername'].valid
                  ) {
                    <mat-error id="integration_auth_username_error" class="error input-error">
                      <i class="fas fa-exclamation-triangle error-icon"></i
                      >{{ getErrorMessage('authUsername') }}
                    </mat-error>
                  }
                </span>
              </div>
            }
            @if (isJwtAuth) {
              <div>
                <div id="form_input_title_auth_password" class="form-input-title">
                  Authentication Password:
                </div>
                <mat-form-field
                  id="integration_auth_password_field"
                  class="form-field-custom form-field-input">
                  <input
                    matInput
                    id="integration_auth_password_input"
                    class="shared-input-field"
                    formControlName="authPassword"
                    autocomplete="off" />
                </mat-form-field>
                <span class="error-space-holder">
                  @if (
                    integrationForm.controls['authPassword'].touched &&
                    !integrationForm.controls['authPassword'].valid
                  ) {
                    <mat-error id="integration_auth_password_error" class="error input-error">
                      <i class="fas fa-exclamation-triangle error-icon"></i
                      >{{ getErrorMessage('authPassword') }}
                    </mat-error>
                  }
                </span>
              </div>
            }
            @if (isOauthAuth) {
              <div>
                <div id="form_input_title_client_id" class="form-input-title">Client ID:</div>
                <mat-form-field
                  id="integration_auth_client_id"
                  class="form-field-custom form-field-input">
                  <input
                    matInput
                    id="integration_client_id_input"
                    class="shared-input-field"
                    formControlName="oauthClientId"
                    autocomplete="off"
                    (focus)="onInputFocus('oauthClientId')"
                    (blur)="onInputBlur('oauthClientId')" />
                </mat-form-field>
                <span class="error-space-holder">
                  @if (
                    integrationForm.controls['oauthClientId'].touched &&
                    !integrationForm.controls['oauthClientId'].valid &&
                    !focusState()['oauthClientId']
                  ) {
                    <mat-error id="integration_client_id_error" class="error input-error">
                      <i class="fas fa-exclamation-triangle error-icon"></i
                      >{{ getErrorMessage('oauthClientId') }}
                    </mat-error>
                  }
                </span>
              </div>
            }
            @if (isOauthAuth) {
              <div>
                <div id="form_input_title_client_secret" class="form-input-title">
                  Client Secret:
                </div>
                <mat-form-field
                  id="integration_auth_client_secret"
                  class="form-field-custom form-field-input">
                  <input
                    matInput
                    id="integration_client_secret_input"
                    class="shared-input-field"
                    formControlName="oauthClientSecret"
                    autocomplete="off"
                    (focus)="onInputFocus('oauthClientSecret')"
                    (blur)="onInputBlur('oauthClientSecret')" />
                </mat-form-field>
                <span class="error-space-holder">
                  @if (
                    integrationForm.controls['oauthClientSecret'].touched &&
                    !integrationForm.controls['oauthClientSecret'].valid &&
                    !focusState()['oauthClientSecret']
                  ) {
                    <mat-error id="integration_client_secret_error" class="error input-error">
                      <i class="fas fa-exclamation-triangle error-icon"></i
                      >{{ getErrorMessage('oauthClientSecret') }}
                    </mat-error>
                  }
                </span>
              </div>
            }
            @if (isOauthAuth) {
              <div>
                <div id="integrations_add_edit_grant_type">
                  <div id="form_input_title_grant_type" class="form-input-title">Grant Type:</div>
                  <mat-form-field
                    id="integration_grant_type_field"
                    class="form-field-custom add-edit-dropdown">
                    <mat-select id="grant_type_select" formControlName="oauthGrantType">
                      @for (type of grantType; track type) {
                        <mat-option id="integration_grant_type_options_{{ type }}" [value]="type">
                          {{ type }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                  <span class="error-space-holder">
                    @if (
                      integrationForm.controls['oauthGrantType'].touched &&
                      !integrationForm.controls['oauthGrantType'].valid
                    ) {
                      <mat-error id="integration_grant_type_error" class="error input-error">
                        <i class="fas fa-exclamation-triangle error-icon"></i
                        >{{ getErrorMessage('oauthGrantType') }}
                      </mat-error>
                    }
                  </span>
                </div>
              </div>
            }

            <div id="integrations_add_edit_enabled">
              <div id="form_input_title_enabled" class="form-input-title">Enabled:</div>
              <mat-form-field
                id="integration_enabled_field"
                class="form-field-custom add-edit-dropdown">
                <mat-select id="enabled_select" formControlName="enabled">
                  @for (enabled of enabledList; track enabled) {
                    <mat-option id="integration_enabled_options_{{ enabled }}" [value]="enabled">
                      {{ enabled }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>

            @if (isFleetApi) {
              <div>
                <div>
                  <div id="form_input_title_response_model" class="form-input-title">
                    Object Strategy:
                  </div>
                  <mat-form-field
                    id="integration_response_model_field"
                    class="form-field-custom add-edit-dropdown">
                    <mat-select id="response_model_select" formControlName="objectStrategy">
                      @for (type of objectStrategies(); track type.strategyName) {
                        <mat-option
                          id="integration_response_model_options_{{ type }}"
                          [value]="type.strategyName">
                          {{ type.strategyName }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                  <span class="error-space-holder">
                    @if (
                      integrationForm.controls['objectStrategy'].touched &&
                      !integrationForm.controls['objectStrategy'].valid
                    ) {
                      <mat-error id="integration_response_model_error" class="error input-error">
                        <i class="fas fa-exclamation-triangle error-icon"></i
                        >{{ getErrorMessage('objectStrategy') }}
                      </mat-error>
                    }
                  </span>
                </div>
              </div>

              <div>
                <div>
                  <div id="form_input_title_distance" class="form-input-title">
                    Distance Measurement:
                  </div>
                  <mat-form-field
                    id="integration_distance_field"
                    class="form-field-custom add-edit-dropdown capitalize">
                    <mat-select id="distance_select" formControlName="distanceMeasurement">
                      @for (option of distanceOptions; track option) {
                        <mat-option
                          id="integration_distance_options_{{ option }}"
                          class="capitalize"
                          [value]="option">
                          {{ option }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                  <span class="error-space-holder">
                    @if (
                      integrationForm.controls['distanceMeasurement'].touched &&
                      !integrationForm.controls['distanceMeasurement'].valid
                    ) {
                      <mat-error id="integration_distance_error" class="error input-error">
                        <i class="fas fa-exclamation-triangle error-icon"></i
                        >{{ getErrorMessage('distanceMeasurement') }}
                      </mat-error>
                    }
                  </span>
                </div>
              </div>

              <div>
                <div>
                  <div id="form_input_title_time" class="form-input-title">Time Measurement:</div>
                  <mat-form-field
                    id="integration_time_field"
                    class="form-field-custom add-edit-dropdown capitalize">
                    <mat-select id="time_select" formControlName="timeMeasurement">
                      @for (option of timeOptions; track option) {
                        <mat-option
                          id="integration_time_options_{{ option }}"
                          class="capitalize"
                          [value]="option">
                          {{ option }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                  <span class="error-space-holder">
                    @if (
                      integrationForm.controls['timeMeasurement'].touched &&
                      !integrationForm.controls['timeMeasurement'].valid
                    ) {
                      <mat-error id="integration_time_error" class="error input-error">
                        <i class="fas fa-exclamation-triangle error-icon"></i
                        >{{ getErrorMessage('timeMeasurement') }}
                      </mat-error>
                    }
                  </span>
                </div>
              </div>
            }

            <div id="integrations_add_edit_cancel" class="buttons-row span-all-cols">
              <button
                mat-button
                id="integrations_cancel_button"
                class="add-edit-button white-button"
                (click)="openWarningDialog()">
                Cancel
              </button>
              <button
                mat-button
                id="integrations_add_edit_save_2"
                class="add-edit-button save-button"
                [ngClass]="{ 'invalid-button': !integrationForm.valid }"
                (click)="onSubmit(integrationForm)">
                Save
              </button>
            </div>
          </form>
          <div class="ass-cus-holder">
            <div id="ass_cus_title" class="bold">
              Associated Customers
              <span id="ass_count" class="ass-count">
                {{ getAssociatedCustomers.length }}
              </span>
            </div>
            <hr />
            <mat-form-field
              id="ass_cus_mat_form"
              class="form-field-custom form-field-input ass-input">
              <input
                matInput
                id="ass_cus_mat_form_input"
                class="shared-input-field"
                placeholder="Filter selected customers"
                maxlength="50"
                autocomplete="off"
                (input)="customerFilter.set($event.target.value)" />
            </mat-form-field>
            <div>
              @if (getAssociatedCustomers.length > 0) {
                <div id="ass_cus_selected_text" class="bold ass-selected-text">Selected</div>
                <div class="max-height">
                  @for (customer of filteredAssociatedCustomers; track customer) {
                    <div id="ass_select_{{ customer }}" class="ass-select">
                      {{ customer }}
                      <span id="ass_select_x_{{ customer }}" (click)="removeCustomer(customer)"
                        >X</span
                      >
                    </div>
                  }
                </div>
              } @else {
                <div id="no_ass" class="no-ass">
                  <span class="bold default-font no-ass-title">No customers selected</span>
                  <span class="small-font">
                    Use the "Customers Associated" dropdown to associate this API with one or more
                    customers.
                  </span>
                </div>
              }
            </div>
          </div>
        </div>
      }

      @if (loading()) {
        <app-loading-spinner />
      }

      @if (formPrepareError() && !loading()) {
        <div id="form_error" class="center-page center form-alternative-fullsize center">
          <div class="form-error-div">
            <img
              id="manager_error_image"
              src="/assets/images/api_error.svg"
              alt="Error"
              width="100" />
            <h1 id="manager_error_text">Oops!</h1>
            <p id="manager_error_content" class="custom-p">
              We have encountered some trouble building this form!
            </p>
          </div>
        </div>
      }
    </mat-card-content>
  </mat-card>
</mat-drawer-container>
